import { render, staticRenderFns } from "./ProductsWinEdit.vue?vue&type=template&id=261415b8&scoped=true&"
import script from "./ProductsWinEdit.vue?vue&type=script&lang=js&"
export * from "./ProductsWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWinEdit.vue?vue&type=style&index=0&id=261415b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261415b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('261415b8')) {
      api.createRecord('261415b8', component.options)
    } else {
      api.reload('261415b8', component.options)
    }
    module.hot.accept("./ProductsWinEdit.vue?vue&type=template&id=261415b8&scoped=true&", function () {
      api.rerender('261415b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductsWinEdit.vue"
export default component.exports